import { useWorkspaceStore } from '../../panels/use-workspace-store';
import { EntityTypeEnum, WorkspaceWindowTypeEnum } from '../../../../../../api-ts-packages/cad-api';
import { assertNonNull } from '../../queues/utils/assert-non-null';
import { useEnabledFeatures } from './enabled-features';

export const useBoloQueueWorkspacePanel = () => {
    const workspacePanels = useWorkspaceStore().getActivePanels();
    const { viewBolos: bolosEnabled } = useEnabledFeatures();

    if (!bolosEnabled) {
        return;
    }

    const foundBoloQueueWorkspacePanel = workspacePanels.find(
        (panel) =>
            panel.workspacePanelType === WorkspaceWindowTypeEnum.QUEUE.name &&
            panel.queue?.dataEntityType === EntityTypeEnum.BOLO.name
    );

    assertNonNull(
        foundBoloQueueWorkspacePanel,
        'Workspace for queue and entity type BOLO not found'
    );

    return foundBoloQueueWorkspacePanel;
};
